import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { DataContainer } from '../../components/DataContainer';
import { sendJobEmails } from '../../store/knownDataSlice';
import { unwrapResult } from '@reduxjs/toolkit';



function SendEmails({ id }) {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.knownData[id]);

    const [clientChecked, setClientChecked] = useState([]);
    const [driverChecked, setDriverChecked] = useState([]);

    const clientOptions = [
        { key: 'departure', label: 'Väljumisaeg', suffix: 'väljumisaega' },
        { key: 'route', label: 'Marsruut', suffix: 'marsruuti' },
        { key: 'passengers', label: 'Reisijate arv', suffix: 'reisijate arvu' },
        { key: 'price', label: 'Hind', suffix: 'hinda' },
        { key: 'driver', label: 'Juht (automaatne)', suffix: 'juhti' },
        { key: 'bus', label: 'Buss (automaatne)', suffix: 'bussi' },
        { key: 'clientNotes', label: 'Kliendi lisainfo', suffix: 'lisainfot' },
        { key: 'foodPackages', label: 'Toidupakid', suffix: 'toidupakke' },
    ];

    const driverOptions = [
        { key: 'route', label: 'Marsruut', suffix: 'marsruuti' },
        { key: 'departure', label: 'Väljumisaeg', suffix: 'väljumisaega' },
        { key: 'passengers', label: 'Reisijate arv', suffix: 'reisijate arvu' },
        { key: 'foodPackages', label: 'Toidupakid', suffix: 'toidupakke' },
        { key: 'clientPhone', label: 'Kliendi telefoninumber', suffix: 'kliendi telefoninumbrit' },
        { key: 'bus', label: 'Buss (automaatne)', suffix: 'bussi' },
        { key: 'clientNotes', label: 'Kliendi lisainfo', suffix: 'kliendi lisainfot' },
        { key: 'driverNotes', label: 'Pane tähele tekst', suffix: 'pane tähele teksti' },
        { key: 'logisticsNotes', label: 'Märkmed juhile', suffix: 'logistiku lisainfot' },
    ];

    function toggleClientOption(key) {
        if(clientChecked.includes(key)) {
            setClientChecked(clientChecked.filter(k => k !== key));
        } else {
            setClientChecked([...clientChecked, key]);
        }
    }

    function toggleDriverOption(key) {
        if(driverChecked.includes(key)) {
            setDriverChecked(driverChecked.filter(k => k !== key));
        } else {
            setDriverChecked([...driverChecked, key]);
        }
    }

    function generateEmailTitle(checkedKeys, options, prefix) {
        if(checkedKeys.length === 0) return null;
        
        const suffixes = checkedKeys.map(key => {
            const option = options.find(opt => opt.key === key);
            return option ? option.suffix : '';
        }).filter(Boolean);

        return `${prefix} ${suffixes.join(', ')}`;
    }

    async function onSend() {
        const clientEmailTitle = generateEmailTitle(clientChecked, clientOptions, 'Teie tellimuses on muudetud');
        const driverEmailTitle = generateEmailTitle(driverChecked, driverOptions, 'Teie töös on muudetud');

        if(!clientEmailTitle && !driverEmailTitle) {
            toast.warning('Ühtegi emaili ei saadetud');
            return;
        }

        await unwrapResult(await dispatch(sendJobEmails({
            id,
            driverEmailTitle,
            clientEmailTitle,
        })));

        const sentEmails = [];
        if(driverEmailTitle) sentEmails.push('juhtidele');
        if(clientEmailTitle) sentEmails.push('kliendile');

        toast.success(`E-kiri saadetud ${sentEmails.join(' ja ')}!`);
    }

    if(!data) {
        return;
    }

    if(!data["job_query_id"]) {
        return;
    }

    return (
        <>
            <hr />

            <DataContainer actionType={"knownData/sendJobEmails"}>
                <div className="column g32">
                    <h2>Saada e-kirjad</h2>

                    <div className="row g32">
                        <div className="column g16" style={{ flex: 1 }}>
                            <h3>Juhid</h3>
                            <div className="column g8">
                                {driverOptions.map(option => (
                                    <label key={option.key} className="row g8 center-cross" style={{ cursor: 'pointer' }}>
                                        <input
                                            type="checkbox"
                                            checked={driverChecked.includes(option.key)}
                                            onChange={() => toggleDriverOption(option.key)}
                                        />
                                        <span>{option.label}</span>
                                    </label>
                                ))}
                            </div>
                        </div>

                        <div className="column g16" style={{ flex: 1 }}>
                            <h3>Klient</h3>
                            <div className="column g8">
                                {clientOptions.map(option => (
                                    <label key={option.key} className="row g8 center-cross" style={{ cursor: 'pointer' }}>
                                        <input
                                            type="checkbox"
                                            checked={clientChecked.includes(option.key)}
                                            onChange={() => toggleClientOption(option.key)}
                                        />
                                        <span>{option.label}</span>
                                    </label>
                                ))}
                            </div>
                        </div>
                    </div>

                    <button onClick={onSend}>Saada e-kirjad</button>

                </div>
            </DataContainer>
        </>
    );
}

export default SendEmails;
